import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IdentityVerificationForm } from '../checkout-forms/IdentityVerificationForm/IdentityVerificationForm';

export const IdentityVerificationSection = ({
  urlPrefix,
  intl,
  SSOid,
  accessToken
}) => {
  return (
    <div data-testingid="identity-verification-section">
      <div style={{ marginBottom: '16px' }}>
        <Text element="h6" typeface="headline-3-b" style={{ margin: '0px' }}>
          <FormattedMessage
            id="identity_verifcation.verify_your_identity"
            defaultMessage="Verify your identity"
          />
        </Text>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <FormattedMessage
          id="identity_verifcation.trust_safety_message"
          defaultMessage="Trust and safety is our top priority and to keep our community safe all new Peerspace customers must verify their identity. We’ve partnered with Stripe for a seamless verification experience. Identity verification must be completed on the Peerspace account holder. {learnMoreLink}"
          values={{
            learnMoreLink: (
              <a
                target="_blank"
                href={`https://support.peerspace.com/hc${urlPrefix}/articles/5141300838420-What-s-needed-to-successfully-complete-identity-verification-`}
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline' }}
              >
                <FormattedMessage
                  id="identity_verifcation.learn_more"
                  defaultMessage="Learn more"
                />
              </a>
            )
          }}
        />
      </div>

      <div>
        <IdentityVerificationForm
          SSOid={SSOid}
          intl={intl}
          accessToken={accessToken}
        />
      </div>
    </div>
  );
};

IdentityVerificationSection.propTypes = {
  urlPrefix: PropTypes.string,
  intl: PropTypes.object,
  SSOid: PropTypes.string,
  accessToken: PropTypes.string
};
